// extracted by mini-css-extract-plugin
export default {"wrap":"OJ-z","subtitle":"PJ-z","contentWrap":"QJ-z","imgWrap":"RJ-z","heading":"SJ-z","copy":"TJ-z"};